import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=a4070606&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=a4070606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4070606",
  null
  
)

export default component.exports